import { render } from "./BaseCollapsible.vue?vue&type=template&id=2cec9dea"
import script from "./BaseCollapsible.vue?vue&type=script&lang=js"
export * from "./BaseCollapsible.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__